import { render, staticRenderFns } from "./AlertResourceCell.vue?vue&type=template&id=449ce384"
import script from "./AlertResourceCell.vue?vue&type=script&lang=js"
export * from "./AlertResourceCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports